// 信箱登入流程
import { useState, useRef, useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { userLogin } from '@/slices/userSlice';
import { setShowLoginModal } from '@/slices/popSlice';

import EmailLoginInput from './EmailLoginInput'; // 步驟一 輸入信箱
import EmailLoginVerify from './EmailLoginVerify'; // 步驟二 輸入驗證碼
import EmailVerifyFail from './EmailVerifyFail'; // 驗證失敗
import authClient from '../../../../common/apiClient/authClient';

const EmailLogin = ({ setShowMail, t }) => {
    const dispatch = useDispatch();

    // 驗證碼輸入框 refs
    const inputRefs = useRef(Array(6).fill(null));

    // 登入驗證流程
    // 1 : 輸入信箱
    // 2 : 輸入驗證碼
    // 3 : 驗證失敗
    const [step, setStep] = useState(1);

    // 信箱輸入
    const [email, setEmail] = useState('');
    // 信箱錯誤提示
    const [hintEmail, setHintEmail] = useState(false);
    // 驗證碼錯誤提示
    const [hintCode, setHintCode] = useState(false);

    // 驗證碼輸入
    const [verifyCode, setVerifyCode] = useState(Array(6).fill(''));

    // 檢查信箱
    const checkMail = () => {
        const pattern = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/g;
        return pattern.test(email);
    };

    // 送出信箱 => 格式正確 發送驗證碼
    const onSubmitEmail = async () => {
        // 檢查格式
        if (checkMail()) {
            onSendCode();
            setStep(2);
        } else {
            setHintEmail(true);
        }
    };

    // 輸入驗證碼
    const handleChangeCode = (value, index) => {
        if (!/^\d?$/.test(value)) return; // 僅允許數字輸入

        const newValues = [...verifyCode];
        newValues[index] = value; // 更新當前框的值
        setVerifyCode(newValues);

        // 如果不是最後一個框，移動焦點到下一個框
        if (value !== '' && index < verifyCode.length - 1) {
            inputRefs.current[index + 1]?.focus();
        } else if (index === verifyCode.length - 1) {
            // 最後一個框，保留焦點
            inputRefs.current[index]?.focus();
        }
    };

    // pc delete 刪除
    const handleKeyDown = (e, index) => {
        setHintCode(false);
        if (e.key === 'Backspace') {
            e.preventDefault(); // 防止刪除非數字
            const newValues = [...verifyCode];
            if (newValues[index] !== '') {
                newValues[index] = ''; // 清空當前框
            } else if (index > 0) {
                newValues[index - 1] = ''; // 清空上一個框
                inputRefs.current[index - 1]?.focus(); // 回到上一個框
            }
            setVerifyCode(newValues);
        }
    };

    // 判斷當前輸入用
    const handleActiveIndex = () => {
        const activeIndex = verifyCode.findIndex((value) => value === '');

        if (activeIndex !== -1) inputRefs.current[activeIndex]?.focus();
    };

    const fetchUser = async () => {
        try {
            const { user } = await authClient.getUser();

            if (user && user?.uid) dispatch(userLogin(user));
        } catch (e) {
            console.error(e);
        }
    };

    // 發送驗證碼
    const onSendCode = async () => {
        await authClient.emailSignin(email);
    };

    // 驗証驗證碼
    const onVerifyCode = async () => {
        try {
            const { user } = await authClient.verifyEmail(email, verifyCode.join(''));
            if (user && user?.uid) {
                fetchUser();
                dispatch(setShowLoginModal(false));
                setShowMail(false);
            }
        } catch (e) {
            console.error(e);
            // 當驗證碼錯誤
            if (e.errMsg === 'Wrong verify code') setHintCode(true);
        }
    };

    // 驗證失敗 再試一次
    // const onRetry = () => {
    //     setVerifyCode(Array(6).fill(''));
    //     setStep(2);
    // };

    useEffect(() => {
        handleActiveIndex();
    }, [verifyCode]);

    useEffect(() => {
        if (step === 2) inputRefs.current[0]?.focus();
    }, [step]);

    return (
        <div className="text-center">
            {/* 輸入信箱 */}
            {step === 1 && (
                <EmailLoginInput
                    t={t}
                    email={email}
                    setEmail={setEmail}
                    hintEmail={hintEmail}
                    setHintEmail={setHintEmail}
                    onSubmitEmail={onSubmitEmail}
                />
            )}

            {/* 輸入驗證碼 */}
            {step === 2 && (
                <EmailLoginVerify
                    t={t}
                    email={email}
                    verifyCode={verifyCode}
                    handleChangeCode={handleChangeCode}
                    handleKeyDown={handleKeyDown}
                    inputRefs={inputRefs}
                    onSendCode={onSendCode}
                    onVerifyCode={onVerifyCode}
                    hintCode={hintCode}
                />
            )}

            {/* 驗證失敗 */}
            {/* {step === 3 && <EmailVerifyFail t={t} onRetry={onRetry} />} */}
        </div>
    );
};

export default EmailLogin;
